export default [
  {
    "id": "1",
    "path": "dashboard",
    "name": 'menu.team',
    "title": 'menu.team',
    "icon": "sidebar-dashboard-icon",
    "class": "sidebar-dashboard"
  },
  // {
  //   "id": "2",
  //   "path": "invitation",
  //   "name": "招待状の管理",
  //   "title": "招待状の管理",
  //   "icon": "sidebar-invitation-icon",
  //   "class": "sidebar-invitation"
  // },
  {
    "id": "3",
    "path": "enterprise",
    "name": 'menu.company',
    "title": 'menu.company',
    "icon": "sidebar-enterprise-icon",
    "class": "sidebar-enterprise"
  },
  {
    "id": "4",
    "path": "orders",
    "name": 'menu.order',
    "title": 'menu.order',
    "icon": "sidebar-order-icon",
    "class": "sidebar-orders"
  },
  {
    "id": "5",
    "path": "logs",
    "name": 'menu.log',
    "title": 'menu.log',
    "icon": "sidebar-logs-icon",
    "class": "sidebar-logs"
  }
]